// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2qyDX","alertIcon":"ConfirmModal_alertIcon__3QXyV"};